(function () {
  'use strict';

  angular
    .module('gestaoOcorrencia', [
      'ui.router',
      'powerbi',
      'restangular',
      'FactoryVfiltroModule',
      'ServiceVfiltroModule'
    ]);
}());
